<searchbar></searchbar>
<section class="content-container">
  <navbar></navbar>
  <router-outlet></router-outlet>
</section>
